import React, { Component } from 'react';
import { Container } from 'flux/utils';
import { ReportDialogs } from '../../constants/Dialogs';

import FlatButton from 'material-ui/FlatButton';
import { Link } from 'react-router';

import DialogActions from '../../actions/DialogActionCreator';
import DialogStore from '../../stores/DialogStore';
import Dialog from 'material-ui/Dialog';

class ReportDownloadDialog extends Component {

    render() {
        if (this.state.open !== ReportDialogs.DOWNLOAD) { return null; } //guard: dialog not open

        return (
            <Dialog
                title={this.state.draft.title}
                open={true}
                modal={false}
                onRequestClose={DialogActions.close}
                actions={[
                    <FlatButton key="cancel" label="Cancel" onTouchTap={DialogActions.close}/>,
                    <Link to={`/cent/report/${this.state.draft.reportId}/results.zip`} onClick={DialogActions.close} target="_blank">
                        <FlatButton key="submit" label="Download" primary/>
                    </Link>
                ]}
            >
                This report is not enabled for web view. Would you like to download the results as a CSV file?
            </Dialog>
        );
    }
}

ReportDownloadDialog.getStores = () => ([DialogStore]);
ReportDownloadDialog.calculateState = (prevState) => {
    const { open, draft } = DialogStore.getState();
    return {
        open,
        draft
    };
};

export default Container.create(ReportDownloadDialog);
